const initialState = {
};

const mypageReducer = (state = initialState, action) => {
    switch(action.type){
        case 'SAVE_NEW_INFO' : {
            return {
                address : action.payload.info.address,
                phone : action.payload.info.phone,
                password : action.payload.info.newPassword,
                greenhouseType : action.payload.info.greenhouseType,
                plantType : action.payload.info.plantType,
                areaSize : action.payload.info.areaSize,
            }
        }break;
        case 'RESET_INFO' : {
            return {}
        }break;
        default : {
            return state;
        }break;
    }
}

export default mypageReducer;


// WEBPACK FOOTER //
// ./src/reducers/mypageReducer.js